import { useCustomerBrandHotelSelection } from 'components/customerBrandHotelSelect/useCustomerBrandHotelSelection';
import { includes } from 'lodash';
import { useRequest, UseRequestHook } from 'redux-query-react';
import { getHeaders } from '../helpers/request/getHeaders';

export const useRequestWithAuth: UseRequestHook = (request) => {
  const { selectedClient } = useCustomerBrandHotelSelection();
  if (!request) {
    return useRequest(request);
  }
  const url = (() => {
    if (!!request.url && selectedClient && selectedClient.id && !includes(request.url, 'selectedClientId=')) {
      const selectedClientIdParam = includes(request.url, '?') ? '&selectedClientId=' : '?selectedClientId=';
      return request.url + selectedClientIdParam + selectedClient.id;
    } else {
      return request.url;
    }
  })();
  const withHeaders = {
    ...request,
    url,
    options: {
      ...request.options,
      headers: getHeaders(),
    },
  };
  return useRequest(withHeaders);
};
